import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './assets/logo.webp';
import wordmark from './assets/wordmark.webp';
import { EmailOutlineIcon } from './icons';
import { LANGS, LANG_NAMES, STRINGS, isLanguage, type Language } from './i18n';

interface HeaderProps {
  language: Language;
  onLanguageChange: (lang: Language) => void;
}

export const Header: React.FC<HeaderProps> = ({ language, onLanguageChange }) => {
  const navigate = useNavigate();
  const t = STRINGS[language].header;
  // язык документа — для шрифтов CJK, переносов и чтения с экрана (шапка есть на каждой странице)
  useEffect(() => { document.documentElement.lang = language; }, [language]);

  return (
    <header className="header">
      <div className="brand" onClick={() => navigate('/')}
        >
        <span className="brand__logo">
          <img src={logo} alt="Qevryno" />
        </span>
        <div>
          <img className="brand__name-img" src={wordmark} alt="Qevryno" />
          <div className="brand__subtitle">{t.brandSubtitle}</div>
        </div>
      </div>
      <div className="header__actions">
        <nav className="header__nav">
          <a
            href={`/about/${language}`}
            onClick={(e) => {
              e.preventDefault();
              navigate(`/about/${language}`);
            }}
          >
            {t.about}
          </a>
        </nav>
        {/* 13 языков (2026-10-24) — список вместо ряда кнопок EN/RU/ES */}
        <label className="language-switch">
          <span className="visually-hidden">{t.language}</span>
          <select
            className="lang-select"
            value={language}
            aria-label={t.language}
            onChange={(e) => { if (isLanguage(e.target.value)) onLanguageChange(e.target.value); }}
          >
            {LANGS.map((lang) => (
              <option key={lang} value={lang}>{LANG_NAMES[lang]}</option>
            ))}
          </select>
        </label>
        <button
          className="btn btn--secondary header__contact"
          onClick={() => navigate(`/contact/${language}`)}
          aria-label={t.contact}
        >
          <EmailOutlineIcon size={20} />
          <span className="header__contact-label">{t.contact}</span>
        </button>
      </div>
    </header>
  );
};
